export const themes = {
    metal : {
        "highlight1" : "#DAE1DC",
        "highlight2" : "#B5CCEB",
        "foreground" : "#38BCA8",
        "background1" : "#9AD2CB",
        "background2" : "#2B3134"
    },
    kalimba : {
        "highlight1" : "#C3BFBF",
        "highlight2" : "#D2B278",
        "foreground" : "#D56C33",
        "background1" : "#77925F",
        "background2" : "#003348"
    },
    fade : {
        "highlight1" : "#FCDDC5",
        "highlight2" : "#DACBC1",
        "foreground" : "#2F90A8",
        "background1" : "#0A2553",
        "background2" : "#181B28"
    },
    wood : {
        "highlight1" : "#ECB069",
        "highlight2" : "#B74B25",
        "foreground" : "#8F432B",
        "background1" : "#763C2C",
        "background2" : "#431811"
    },
    synth : {
        "highlight1" : "#55e7ff",
        "highlight2" : "#00ccfd",
        "foreground" : "#ff34b3",
        "background1" : "#2011a2",
        "background2" : "#201148"
    }
}